"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
const token_type_1 = require("./token-type");
class Token {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    toString() {
        return `${token_type_1.TokenType[this.type]}: ${this.value}`;
    }
}
exports.Token = Token;
//# sourceMappingURL=token.js.map